<mat-drawer-container autosize class="fg-drawer-container">

  <mat-drawer-content >
    <router-outlet></router-outlet>
    <app-spinner></app-spinner>
    <fg-scroll-to-top></fg-scroll-to-top>
    <fg-cookie-consent></fg-cookie-consent>
    <fg-event-handler></fg-event-handler>    
  </mat-drawer-content>

</mat-drawer-container>

